import React, { Children } from 'react';

import {
  string,
  shape,
  oneOfType,
  arrayOf,
  node,
  func,
  oneOf
} from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';
import Trigger from '../.internal/trigger/Trigger';

import './Popover.scss';

export default class Popover extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      status: false
    };
  }

  handlePopoverOnChange = status => {
    this.setState({
      status
    });
  };

  render() {
    const { children, trigger, style, id, className, position } = this.props;

    const triggerIndex = Children.toArray(children).findIndex(child => {
      return typeof child.props.trigger !== 'undefined';
    });

    const triggerElement = Children.toArray(children).find(child => {
      return typeof child.props.trigger !== 'undefined';
    });

    const popoverContent = Children.toArray(children);

    if (triggerIndex !== -1) {
      popoverContent.splice(triggerIndex, 1);
    }

    const classes = ['Popover-content', className, position];

    const classNames = ClassNames(classes);

    return (
      <Trigger
        overlayClassName="Overlay-container"
        overrideVisible={this.state.status}
        onChange={this.handlePopoverOnChange}
        autoAdjust={false}
        popup={
          <div className={classNames} style={style} id={id}>
            <div className={`arrow ${position}`} />
            {popoverContent}
          </div>
        }
        action={trigger}
        position={position}
      >
        {triggerElement}
      </Trigger>
    );
  }
}

Popover.propTypes = {
  trigger: oneOf(['hover', 'click']),
  position: oneOf(['top', 'bottom', 'left', 'right']),
  style: shape({}),
  id: string,
  className: string,
  onChange: func,
  children: oneOfType([arrayOf(node), node])
};

Popover.defaultProps = {
  trigger: 'hover',
  position: 'right',
  style: {},
  id: undefined,
  className: undefined
};
